var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { CorrelationVector } from '@augloop/logging';
import { EventEmitter } from 'eventemitter3';
var EmptySessionManager = /** @class */ (function (_super) {
    __extends(EmptySessionManager, _super);
    function EmptySessionManager() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EmptySessionManager.prototype.init = function () {
        return Promise.resolve();
    };
    EmptySessionManager.prototype.sendMessage = function (_message, _onResponse) {
    };
    EmptySessionManager.prototype.onMessage = function (_messageType, _messageCallback) {
    };
    EmptySessionManager.prototype.forceReconnect = function () {
        return Promise.resolve();
    };
    EmptySessionManager.prototype.closeSession = function () {
    };
    EmptySessionManager.prototype.sendBytes = function (_buffer) {
    };
    EmptySessionManager.prototype.getCorrelationVector = function () {
        return new CorrelationVector();
    };
    EmptySessionManager.prototype.setState = function (_newState) {
    };
    return EmptySessionManager;
}(EventEmitter));
export { EmptySessionManager };
//# sourceMappingURL=empty-session-manager.js.map